import { Section, Container, Eyebrow, DisplayH1, Reveal } from "@/components/Layout";
import { StatNumber } from "@/components/StatNumber";

export default function Investors() {
  return (
    <>
      <Section testid="investors-hero" className="pt-40 pb-16">
        <Container>
          <Eyebrow>Investor Relations · 2026</Eyebrow>
          <DisplayH1 className="mt-6 max-w-4xl">The category-defining institution in canine education.</DisplayH1>
          <p className="mt-8 max-w-2xl text-lg text-[color:var(--wk-bone-dim)] leading-relaxed">
            Twenty-four years of growth, six revenue streams, and an addressable market
            approaching $32B globally. This is the platform that consolidates it.
          </p>
        </Container>
      </Section>

      <Section testid="investors-metrics" className="py-16 border-y border-white/10">
        <Container>
          <div className="grid gap-16 md:grid-cols-4">
            <StatNumber value={72} suffix="%" label="YoY growth" />
            <StatNumber value={6} label="Revenue streams" />
            <StatNumber value={38} suffix="+" label="Countries" />
            <StatNumber value={94} suffix="%" label="Alumni referral" />
          </div>
        </Container>
      </Section>

      <Section testid="investors-thesis" className="py-24">
        <Container>
          <div className="grid gap-16 lg:grid-cols-2">
            <Reveal>
              <Eyebrow>Mission</Eyebrow>
              <div className="mt-4 font-serif-display text-3xl leading-tight">To become the world's leading canine institution — spanning education, media, and social good.</div>
            </Reveal>
            <Reveal delay={0.1}>
              <Eyebrow>Vision</Eyebrow>
              <div className="mt-4 font-serif-display text-3xl leading-tight">A universally trained dog population within a generation.</div>
            </Reveal>
          </div>
        </Container>
      </Section>

      <Section testid="investors-lines" className="pb-32">
        <Container>
          <Eyebrow>Revenue Lines</Eyebrow>
          <div className="mt-8 grid gap-6 md:grid-cols-3">
            {[
              { name: "Residence Programs", desc: "Premium in-person training with 12-week to 18-month cohorts." },
              { name: "Online University", desc: "Global self-paced and cohort courses with AI-assisted tutoring." },
              { name: "Wolfkeeper Plus", desc: "Recurring membership community and continuing education." },
              { name: "Certification & Licensing", desc: "Trainer certification, franchise, and country partnerships." },
              { name: "Media & Publishing", desc: "Documentary, podcast, magazine and book publishing." },
              { name: "Retail & Merchandise", desc: "Luxury store, apparel, equipment and gift subscriptions." },
            ].map((r) => (
              <div key={r.name} className="card-lux p-8">
                <div className="font-serif-display text-2xl">{r.name}</div>
                <p className="mt-3 text-sm text-[color:var(--wk-bone-dim)] leading-relaxed">{r.desc}</p>
              </div>
            ))}
          </div>
        </Container>
      </Section>
    </>
  );
}
